export enum ImageVariationEnum {
  ORIGINAL = "original",
  LARGE = "large",
  MEDIUM = "medium",
  AVATAR = "avatar",
  OFFER_REQUEST = "offer-request",

  BOTTLE_LARGE = "bottle-large",
  BOTTLE_MEDIUM = "bottle-medium",
  BOTTLE_MEDIUM_SQUARE = "bottle-medium-square",
  BOTTLE_SMALL = "bottle-small",
  BOTTLE_SMALL_SQUARE = "bottle-small-square",

  LABEL = "label",
  LABEL_LARGE = "label-large",
  LABEL_MEDIUM = "label-medium",
  LABEL_MEDIUM_SQUARE = "label-medium-square",
  LABEL_SMALL_SQUARE = "label-small-square",
}
